<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 class="fmh" id="_idParaDest-2"><a id="_idTextAnchor001"></a><a href="#/text/9780062258236_Contents#r_idParaDest-2"><span class="right_1" epub:type="pagebreak" id="page_viii" title="viii"><span class="right_1" epub:type="pagebreak" id="page_vii" title="vii">Epigraph</span></span></a></h2>
<p class="epi"><i>And ye lucky livers, to whom, by some rare fatality, your Cape Horns are placid as Lake Lemans, flatter not yourselves that good luck is judgment and discretion; for all the yolk in your eggs, you might have foundered and gone down, had the Spirit of the Cape said the word.</i></p>
<p class="epi_attr">—HERMAN MELVILLE, “ROUNDING CAPE HORN”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062258236_Epigraph.vue?67b9b336